import isEmpty from 'lodash/isEmpty';
import React, { forwardRef } from 'react';
import { Widget, DataView, SortableWidgetProps } from '@creditsights/styleguide-web';
import { useFetchRecentlyViewed } from '../../../hooks/recentlyViewed';
import { getExpandedViewConfig } from '../common/viewConfigs';
import { ArticleTableRow } from '../../../models/ArticleTableRow';

import { useBreakpoint } from '../../../hooks/common';

const getKey = (article: ArticleTableRow) => article.id;

const RecentlyViewed = (props: SortableWidgetProps, ref): React.ReactElement | null => {
  const { isTabletPortrait } = useBreakpoint();
  const { isDragged } = props;
  const { data, isLoading, isError, refetch } = useFetchRecentlyViewed(!isDragged);

  const config = getExpandedViewConfig(isTabletPortrait);

  const renderRecentlyViewed = () => {
    if (!data || isEmpty(data)) {
      return <p>No recently viewed articles.</p>;
    }
    return <DataView data={data} config={config} getKey={getKey} expanded />;
  };

  return (
    <Widget
      headerTitle="Recently Viewed"
      isLoading={isLoading}
      isError={isError}
      onRetryAfterErrorClick={refetch}
      fixedHeight
      wrapFirstLine
      dataTestId="recently-viewed"
      ref={ref}
      {...props}
    >
      {renderRecentlyViewed()}
    </Widget>
  );
};

export default forwardRef(RecentlyViewed);
